// Office images
import allStaff from '../assets/images/gallery/office/all-staff.png';
import admin from '../assets/images/gallery/office/admin.jpg';
import sales from '../assets/images/gallery/office/sales.jpg';
import qcDept from '../assets/images/gallery/office/qc-dept.jpg';
import warehouseOffice from '../assets/images/gallery/office/warehouse-office.jpg';
import warehouseStaff from '../assets/images/gallery/office/warehouse.jpg';

// Warehouse images
import warehouseMain from '../assets/images/gallery/warehouse/warehouse-main.jpeg';

// Activities images
import pezaTour from '../assets/images/gallery/activities/peza-tour-2025.jpg';
import neonRun from '../assets/images/gallery/activities/neon-run.jpg';
import unnamed from '../assets/images/gallery/activities/unnamed.jpg';
import splendidoTaalRun from '../assets/images/gallery/activities/splendido-taal-run.png';
import colorManilaRun from '../assets/images/gallery/activities/color-manila-run.png';
import redCrossRun from '../assets/images/gallery/activities/red-cross-run.png';
import cleanGreenTreePlanting from '../assets/images/gallery/activities/clean-green-tree-planting.png';
import tanimBundokMakiling from '../assets/images/gallery/activities/tanim-bundok-makiling.png';
import companyBeachOuting from '../assets/images/gallery/activities/company-beach-outing.jpg';
import teamLakeOuting from '../assets/images/gallery/activities/team-lake-outing.jpg';
import beachTeamDay from '../assets/images/gallery/activities/beach-team-day.jpg';
import baguioTour from '../assets/images/gallery/activities/baguio-tour.jpg';
import ilocosNorteTour from '../assets/images/gallery/activities/ilocos-norte-tour.jpg';
import viganBaluarteTour from '../assets/images/gallery/activities/vigan-baluarte-tour.jpg';
import viganHeritageTour from '../assets/images/gallery/activities/vigan-heritage-tour.jpg';
import taalVolcanoOuting from '../assets/images/gallery/activities/taal-volcano-outing.jpg';
import teamBuildingCamp from '../assets/images/gallery/activities/team-building-camp.jpg';

const gallery = [
  {
    category: 'Office & Personnel',
    images: [
      { src: allStaff, title: 'All Staff' },
      { src: admin, title: 'Admin Department' },
      { src: sales, title: 'Sales Department' },
      { src: qcDept, title: 'Quality Control Department' },
      { src: warehouseOffice, title: 'Warehouse Office' },
      { src: warehouseStaff, title: 'Warehouse Staff' },
    ],
  },
  {
    category: 'Warehouse',
    images: [
      { src: warehouseMain, title: 'Warehouse' },
    ],
  },
  {
    category: 'Company Activities & CSR',
    images: [
      { src: pezaTour, title: 'PEZA Tour 2025' },
      { src: neonRun, title: 'NEON RUN' },
      { src: splendidoTaalRun, title: 'Splendido Taal Run' },
      { src: colorManilaRun, title: 'Color Manila Run' },
      { src: redCrossRun, title: 'Run to Save Lives — Red Cross' },
      { src: cleanGreenTreePlanting, title: 'Clean & Green Tree Planting' },
      { src: tanimBundokMakiling, title: 'Tanim para sa Bundok Makiling' },
      { src: companyBeachOuting, title: 'Company Beach Outing' },
      { src: teamLakeOuting, title: 'Team Lake Outing' },
      { src: beachTeamDay, title: 'Beach Team Day' },
      { src: baguioTour, title: 'Baguio Tour' },
      { src: ilocosNorteTour, title: 'Ilocos Norte Tour' },
      { src: viganBaluarteTour, title: 'Vigan & Baluarte Tour' },
      { src: viganHeritageTour, title: 'Vigan Heritage Tour' },
      { src: taalVolcanoOuting, title: 'Taal Volcano Outing' },
      { src: teamBuildingCamp, title: 'Team Building Camp' },
      { src: unnamed, title: 'Company Activity' },
    ],
  },
];

export default gallery;
